import React from 'react';
import ReactDOM from 'react-dom';
import Message from '../template/Message';
import { launch } from './serviceLauncher';

export function showForegroundNotification(title, text, json, timeout) {
    createForegroundNotification(title, text, json, null, timeout);
}

export function showForegroundNotificationWithButton(title, text, json, buttonText, timeout) {
    createForegroundNotification(title, text, json, buttonText, timeout);
}

function createForegroundNotification(title, text, json, buttonText, timeout) {
    json = json || {};
    const element = (
        <Message open={true} variant="notification" title={title} text={text} 
            buttonText={buttonText} vertical="top" handleClose={closeMessage}
            action={()=>{launch(json);closeMessage()}} />
    );
    setTimeout(() => ReactDOM.render(element, document.getElementById('meuinss-foreground-notification')));

    function closeMessage(event, reason) {
        if(reason !== "clickaway") {
            ReactDOM.render(null, document.getElementById('meuinss-foreground-notification'));
        }
    }
}